import React from 'react';

import { Text } from 'src/common/components/text/text';

import { Cookie } from '../types/cookieTypes';

interface CookieTableProps {
  cookies: Cookie[];
}

const CookieTable: React.FC<CookieTableProps> = ({ cookies }) => {
  if (cookies.length === 0) {
    return null;
  }

  const formatExpiry = (cookie: Cookie): string => {
    if (cookie.session) {
      return 'Session';
    }
    if (cookie.expiry === '0') {
      return '< 1';
    }
    return cookie.expiry;
  };

  return (
    <div className="cookie-table">
      <table className="cookie-table__table">
        <thead className="cookie-table__header">
          <tr>
            <th className="cookie-table__header-cell">Name</th>
            <th className="cookie-table__header-cell">Host</th>
            <th className="cookie-table__header-cell">Description</th>
            <th className="cookie-table__header-cell">Expiry (days)</th>
          </tr>
        </thead>
        <tbody>
          {cookies.map((cookie, index) => (
            <tr
              key={`${cookie.name}-${cookie.host}-${index}`}
              className="cookie-table__row"
            >
              <td className="cookie-table__cell">
                <code className="cookie-table__cookie-name">{cookie.name}</code>
              </td>
              <td className="cookie-table__cell">
                <Text>{cookie.host}</Text>
              </td>
              <td className="cookie-table__cell">
                <Text>{cookie.description || 'Not available'}</Text>
              </td>
              <td className="cookie-table__cell">
                <Text>{formatExpiry(cookie)}</Text>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CookieTable;
